//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class AddRoleModel extends ModelBase {
      static readonly $typeName = 'AddRoleModel';
      public description: string;
      public name: string;
      public type: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/security/models/AddRoleModel.ts